import { el } from "@dhx/ts-common/dom";
import { isType } from "@dhx/ts-common/core";
import { Text } from "./Text";
import { PropertyEvents } from "../types";

export class Textarea extends Text {
	private _isArray = false;

	setValue(value: any, silent?: boolean) {
		if (isType(value) === "array") {
			value = value.join("\n");
			this._isArray = true;
		}
		const old = this._config.value;
		if (value !== old) {
			this._config.value = value;
			if (!silent) {
				this._evs.fire(PropertyEvents.change, [this._config.id, value, old]);
			}
		}
	}
	getValue() {
		return this._isArray ? this._config.value.split(/\r?\n/) : this._config.value;
	}
	toVDOM(view) {
		const { placeholder = "", label, value, isValid } = this._config;
		return el(
			".edit-section.text-edit",
			{
				_key: this._uid,
			},
			[
				el(".section-title", label),
				el("textarea.dhx_textarea", {
					placeholder,
					value,
					class: isValid ? "" : "dhx_invalid",
					_ref: this._uid,
					onchange: this._handlers.change,
					oninput: this._handlers.change,
					rows: this._getRows(value, view),
				}),
			]
		);
	}
	private _getRows(value: string, view): number {
		const rows = value.toString().split(/\r|\r\n|\n/).length;
		let totalRows = 1;

		if (rows >= 5) {
			totalRows = rows;
		} else {
			const textareaWidth = view?.node?.el?.clientWidth - 40 || 230;
			const element = document.createElement("textarea");
			element.className = "dhx_textarea";
			element.style.width = `${textareaWidth}px`;
			element.value = value;
			element.rows = 1;
			document.body.appendChild(element);

			const height = element.scrollHeight;
			const calculateRows = Math.round((height - 18) / 20);

			document.body.removeChild(element);
			totalRows = Math.max(rows, calculateRows);
		}

		return totalRows > 5 ? 5 : totalRows;
	}
}
